import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import WINDOW_TITLES from 'window_titles'
import {
    getPeripheryById,
    isSortiesAvailable,
    isFortBattlesAvailable,
} from 'helpers/peripheries'
import { formatMessage } from 'locale'
import { openBattleWizard } from 'state/actions/unit_create'

import { ButtonSmall } from 'react-wot-bootstrap'
import CreateUnitButtonTooltip from '../CreateUnitButtonTooltip/CreateUnitButtonTooltip'
import { BATTLE_ROOMS_CREATE_UNIT_BUTTON_CAPTION } from './constants'

const COOLDOWN = 3000

export class CreateUnitButton extends React.Component {
    static propTypes = {
        openBattleWizard: PropTypes.func.isRequired,
        meta: PropTypes.object.isRequired,
        peripheryId: PropTypes.number.isRequired,
        peripheryName: PropTypes.string.isRequired,
    }

    state = { cooldown: false }

    constructor() {
        super()
        this.openBattleWizard = this.openBattleWizard.bind(this)
    }

    componentWillUnmount() {
        if (this.state.cooldown) clearTimeout(this.cooldownTimer)
    }

    resetCooldown() {
        this.setState({ cooldown: false })
    }

    openBattleWizard() {
        this.props.openBattleWizard()
        this.setState({ cooldown: true })
        this.cooldownTimer = setTimeout(() => this.resetCooldown(), COOLDOWN)
    }

    render() {
        const sortiesPeriphery = getPeripheryById(
            this.props.meta.sorties.peripheries,
            this.props.peripheryId,
        )
        const fortBattlesPeriphery = getPeripheryById(
            this.props.meta.fort_battles.peripheries,
            this.props.peripheryId,
        )

        const isBattlesAvailable = isSortiesAvailable(sortiesPeriphery) || isFortBattlesAvailable(fortBattlesPeriphery)

        const button = (
            <ButtonSmall
                onClick={this.openBattleWizard}
                isDisabled={!isBattlesAvailable || this.state.cooldown}
                tooltipId={isBattlesAvailable ? null : CreateUnitButtonTooltip.id}
            >
                {BATTLE_ROOMS_CREATE_UNIT_BUTTON_CAPTION}
            </ButtonSmall>
        )

        return (
            <div>
                {button}
                <CreateUnitButtonTooltip
                    meta={this.props.meta}
                    peripheryName={this.props.peripheryName}
                />
            </div>
        )
    }
}

const mapStateToProps = state => ({
    meta: state.availableUnits.meta,
    peripheryId: state.account.periphery_id,
    peripheryName: state.account.periphery_name,
})

const mapDispatchToProps = {
    openBattleWizard: () => openBattleWizard(formatMessage(WINDOW_TITLES.wizard_create)),
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateUnitButton)



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/CreateUnitButton/CreateUnitButton.jsx